export default "__VITE_ASSET__wRbN5Y6R__"